<template>
    <div class="Media" :class="{'Media--videopaused': isVideoPaused}">
        <video ref="video"
            v-if="props.video"
            :autoplay="props.autoplay"
            :controls="props.controls"
            :mute="props.mute"
            :loop="props.loop"
            :poster="props.image ? props.image.src : ''"
            @playing="isVideoPaused = false"
            @pause="isVideoPaused = true"
            type="video/mp4"
            playsinline
            webkit-playsinline
            crossorigin>
            <source :src="getMediaPath(props.video.src)">
        </video>
        
        <LinkWrapper v-else-if="props.image && props.link[0]" :link="props.link[0]">
            <img ref="image" :src="getMediaPath(props.image.src)">
        </LinkWrapper>

        <img ref="image" v-else-if="props.image" :src="getMediaPath(props.image.src)">

        <iframe ref="youtube"
            v-else-if="props.youtubeLink !== ''"
            :src="youtubeURL"
            frameborder="0"
            allowfullscreen="allowfullscreen"
            mozallowfullscreen="mozallowfullscreen" 
            msallowfullscreen="msallowfullscreen" 
            oallowfullscreen="oallowfullscreen" 
            webkitallowfullscreen="webkitallowfullscreen"></iframe>
    </div>
</template>
<script>
import LinkWrapper from './LinkWrapper.vue';

export default {
    name: "Media",
    props: ["props"],
    components: {
        LinkWrapper
    },
    data() {
        return {
            videoReady: false,
            isVideoPaused: false,
            youtubeID: ''
        }
    },
    created() {
        if(this.props.youtubeLink !== '') 
            this.youtubeID = this.getYoutubeID(this.props.youtubeLink);
    },
    methods: {
        getMediaPath(src) {
            return app.manifest.getMediaPath(src)
        },
        getYoutubeID(url) {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            var match = url.match(regExp);
            return (match && match[2].length === 11) ? match[2] : null;
        }
    },
    computed: {
        youtubeURL () {
            return `https://www.youtube.com/embed/${this.youtubeID}`
        }
    }
}
</script>
<style lang="scss">
    .Media{ 
        position: relative;
        width: 100%;
        max-width: var(--media-max-width);
        padding: var(--content-padding);

        video, img, iframe {
            width: 100%;
        }

        iframe {
            aspect-ratio: 16 / 9;
        }

        &::after {
            content: none;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: 60px;
            height: 60px;
            pointer-events: none;
            background-image: url(@/assets/img/ui/btn-play.svg);
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            z-index: 2;
        }

        &.Media--videopaused {
            video {
                cursor: pointer;
            }

            &::after {
                content: '';
            }
        }
    }
</style>